import { useTheme } from "../theme/ThemeContext";

// Iter78 — new brand mark provided by client (May 2026). Two variants:
//   - dark-bg.png  → robot + light-on-dark wordmark (used on dark themes
//     and the landing hero / footer / login).
//   - light-bg.png → robot + dark wordmark for white sidebars / panels.
const LIGHT_LOGO = "/logos/agentelead-pro-light-bg.png";
const DARK_LOGO = "/logos/agentelead-pro-dark-bg.png";

export default function Logo({ className = "w-9 h-9 object-contain", testid = "app-logo" }) {
  const { theme } = useTheme();
  const src = theme === "dark" ? DARK_LOGO : LIGHT_LOGO;
  return (
    <img
      src={src}
      alt="AgenteLead Pro"
      data-testid={testid}
      data-theme-aware="true"
      className={className}
    />
  );
}
